module.exports = __webpack_public_path__ + "static/media/edit_note.70a334e4.svg";